import './App.css';
import React from 'react';
import { ToastContainer } from 'react-toastify';
import Loader from './Loader';
import 'react-toastify/dist/ReactToastify.css';
import AppRoutes from './routes/AppRoutes';
import './styles/main.css';
import VersionUpdatePopup from './components/Layouts/VersionUpdatePopup';

function App() {
  return (
    <div className="App">
      <Loader />
      <AppRoutes />
      <VersionUpdatePopup />
      <ToastContainer />
    </div>
  );
}

export default App;
